module.exports = __webpack_public_path__ + "img/gallery01.4cb3b7cf.jpg";